module.exports = __webpack_public_path__ + "static/q7answer2_fireplace_wishmas-5a098e16950c79b002220d7c633c57ef.jpg";